/* eslint-disable react/jsx-props-no-spreading */
import React, { type SVGProps } from 'react';

const PanCard = ({
  color = 'var(--secondaryText)',
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={18}
    fill="none"
    {...props}
    data-palette="PanCard">
    <rect
      fill="none"
      width={21.333}
      height={16}
      x={1.334}
      y={0.502}
      stroke={color}
      rx={1.333}
    />
    <path
      fill={color}
      d="M6.471 5.692c.455 0 .85.08 1.184.241.34.16.6.391.78.69.18.3.27.656.27 1.069 0 .406-.09.762-.27 1.067-.18.3-.44.53-.78.69-.335.161-.73.242-1.184.242H5.287v1.621h-.974v-5.62h2.158Zm-.045 3.116c.425 0 .747-.097.967-.29.22-.192.33-.468.33-.826 0-.36-.11-.635-.33-.827-.22-.193-.542-.29-.967-.29H5.287v2.233h1.14ZM12.816 10.012h-2.623l-.517 1.3H8.672l2.36-5.62h.96l2.367 5.62H13.34l-.524-1.3Zm-.323-.82-.989-2.456-.981 2.457h1.97ZM19.687 5.692v5.62h-.802l-2.892-3.805v3.806h-.967v-5.62h.802l2.893 3.805V5.692h.966Z"
    />
  </svg>
);
export default PanCard;
